import { Outlet } from 'react-router-dom';

import { Container } from '@mui/material';

import LayoutHeader from './layout-components/layout-header/LayoutHeader';
import LayoutTabs from './layout-components/layout-tabs/LayoutTabs';

export default function InspectorProfileLayout() {
  return (
    <Container maxWidth="lg">
      <LayoutHeader />
      <LayoutTabs />
      <Outlet />
    </Container>
  );
}
